// extracted by mini-css-extract-plugin
export var container = "bib-calendar-module--container--f6fe7";
export var containerButton = "bib-calendar-module--containerButton--8532f";
export var containerSkeletonLoader = "bib-calendar-module--containerSkeletonLoader--3f8df";
export var diverror = "bib-calendar-module--diverror--ed2d8";
export var loading = "bib-calendar-module--loading--d2f4c";
export var perror = "bib-calendar-module--perror--b4391";
export var perrorTwo = "bib-calendar-module--perrorTwo--7c75c";
export var root = "bib-calendar-module--root--3cb68";
export var skeletonCell = "bib-calendar-module--skeletonCell--d2098";
export var skeletonHeader = "bib-calendar-module--skeletonHeader--6d261";
export var skeletonLoader = "bib-calendar-module--skeletonLoader--ad15d";
export var tableContainer = "bib-calendar-module--tableContainer--97cc7";